<template>
     <div class="Audio-4">
         <reportTemp v-if="frashState" @go-frash="frashCtrls" :repType="1" />
     </div>
</template>

<script>
import reportTemp from '@/views/provinceRole/Audio_Elect/commonReport';
export default {
     components:{
         reportTemp
     },
     data(){
         return{
            frashState:true
         }
     },
     methods:{
         frashCtrls:function(){
            this.frashState = false
            this.$nextTick(() => (this.frashState = true));
         }
     }
}
</script>

<style lang="scss">

</style>



// WEBPACK FOOTER //
// audioReport.vue?659edc01